import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0aa15444"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-weekly ba-column-title ba-text ba-column-relative"
};
const _hoisted_2 = {
  class: "spinner_container"
};
const _hoisted_3 = ["id"];
const _hoisted_4 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_5 = {
  class: "ba-text weekly-ai"
};
const _hoisted_6 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_7 = {
  class: "ba-double-content"
};
const _hoisted_8 = {
  class: "weekly-custom"
};
const _hoisted_9 = ["id"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-text",
  style: {
    "max-width": "200px",
    "text-align": "left"
  }
}, " Last budget before pausing the campaign. ", -1));
const _hoisted_11 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_12 = {
  class: "weekly-custom"
};
const _hoisted_13 = {
  class: "weekly-settings"
};
const _hoisted_14 = ["id"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "blocked-text"
}, "Reset value", -1));
const _hoisted_16 = {
  class: "ba-text ba-text-blue"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-text",
  style: {
    "width": "300px",
    "text-align": "left"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "popover-title"
}, " Campaign group is paused "), /*#__PURE__*/_createTextVNode(" Setting a weekly budget does not automatically activate the campaign group. You must manually activate the campaign group to utilize the assigned budget. ")], -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popover-text",
  style: {
    "max-width": "200px",
    "text-align": "left"
  }
}, " AI proposed budget. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_clock_rewind_icon = _resolveComponent("clock-rewind-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_b_spinner, {
    small: ""
  })], 512), [[_vShow, $props.loading]]), _withDirectives(_createElementVNode("div", {
    class: "weekly-box",
    onClick: _cache[3] || (_cache[3] = () => {
      this.$emit('weekly-edit');
    }),
    id: $props.item_id
  }, [_withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [$props.item.isCustom ? (_openBlock(), _createBlock(_component_app_icon, {
    key: 0,
    icon: "gear",
    size: 14
  })) : (_openBlock(), _createBlock(_component_app_icon, {
    key: 1,
    icon: "ai",
    size: 14,
    color: "#5A52AE"
  })), _createVNode(_component_currency_value, {
    value: 0,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["currency", "precision"])]), _createElementVNode("div", {
    class: "ba-double-content-inner",
    id: `last_budget_${$props.item_id}`
  }, [_createVNode(_component_clock_rewind_icon, {
    width: 12,
    height: 12,
    color: "#93999F"
  }), _createVNode(_component_currency_value, {
    value: $props.item.budgetCurrent,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"]), $props.is_paused ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 0,
    target: `last_budget_${$props.item_id}`,
    "auto-width": "",
    placement: "left"
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["target"])) : _createCommentVNode("", true)], 8, _hoisted_9)])])])], 512), [[_vShow, $props.is_paused]]), _withDirectives(_createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_app_icon, {
    icon: "gear",
    size: 14
  })]), _createElementVNode("div", {
    class: "weekly-reset",
    id: `resetperf${$props.item_id}`,
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {
      this.$emit('weekly-reset');
    }, ["stop"]))
  }, [_createVNode(_component_app_icon, {
    icon: "reset",
    size: 14,
    color: "#4C8EFF"
  })], 8, _hoisted_14), _createVNode(_component_app_popover, {
    target: `resetperf${$props.item_id}`,
    "auto-width": "",
    placement: "top",
    onPopupShown: _cache[1] || (_cache[1] = () => {
      this.$emit('weekly-popup-shown');
    }),
    onPopupHidden: _cache[2] || (_cache[2] = () => {
      this.$emit('weekly-popup-hidden');
    })
  }, {
    default: _withCtx(() => [_hoisted_15]),
    _: 1
  }, 8, ["target"]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_currency_value, {
    value: $props.item.budgetCurrent,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false,
    style: {
      "cursor": "pointer"
    }
  }, null, 8, ["value", "currency", "precision"])])], 512), [[_vShow, $props.item.isCustom]]), _createElementVNode("div", {
    class: _normalizeClass(["weekly-ai", {
      'weekly-custom': $props.item.isCustom
    }]),
    style: {
      "cursor": "pointer"
    }
  }, [_createVNode(_component_app_icon, {
    icon: "ai",
    size: $props.item.isCustom ? 12 : 14,
    color: $props.item.isCustom ? '#A8A0FF' : '#5A52AE'
  }, null, 8, ["size", "color"]), _createElementVNode("div", {
    class: _normalizeClass(["ba-text", {
      'ba-text-small ba-text-xs ba-text-purple ba-text-lighter': $props.item.isCustom
    }]),
    style: {
      "cursor": "pointer"
    }
  }, [_createVNode(_component_currency_value, {
    value: $props.item.budgetAi,
    currency: $props.currency,
    precision: $props.currency_precision,
    allowPrecisionModification: false,
    style: {
      "cursor": "pointer"
    }
  }, null, 8, ["value", "currency", "precision"])], 2)], 2)], 512), [[_vShow, !$props.is_paused]])], 8, _hoisted_3), [[_vShow, !$props.loading]]), $props.is_paused ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 0,
    target: $props.item_id,
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_17]),
    _: 1
  }, 8, ["target"])) : _createCommentVNode("", true), !$props.is_paused && !$props.item?.isCustom ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 1,
    target: $props.item_id,
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_18]),
    _: 1
  }, 8, ["target"])) : _createCommentVNode("", true)]);
}